
namespace Matrix.Exceptions {

    @Serenity.Decorators.registerEditor('Matrix.Exceptions.ExceptionTagEditor')
    export class ExceptionTagEditor extends Serenity.SelectEditor {

        constructor(hidden: JQuery) {
            super(hidden, {
                delimited: true,
                multiple: true
            });
        }

        protected isAutoComplete() {
            return true;
        }

        protected getSelect2Options() {
            var opt = super.getSelect2Options();
            opt.tags = [];
            return opt;
        }
    }
}